import { useEffect, useState } from "react";
import { Outlet, useOutletContext, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import api from "../lib/api";

function PromoBanner() {
  const [b, setB] = useState(null);
  useEffect(() => { api.get("/catalog").then(({ data }) => { const p = (data.promos || []).find((x) => x.show_banner && x.banner_text); if (p && sessionStorage.getItem(`promo-x-${p.id}`) !== "1") setB(p); }).catch(() => {}); }, []);
  useEffect(() => { document.documentElement.style.setProperty("--promo-h", b ? "40px" : "0px"); return () => document.documentElement.style.setProperty("--promo-h", "0px"); }, [b]);
  if (!b) return null;
  return (
    <>
    <div className="fixed top-0 inset-x-0 z-[60] h-10 flex items-center justify-center text-white text-sm font-semibold text-center px-10" style={{ background: b.banner_color || "#FF6500" }} data-testid="promo-site-banner">
      <a href={b.banner_link || "/contact"} className="hover:underline truncate">{b.banner_text}</a>
      <button onClick={() => { sessionStorage.setItem(`promo-x-${b.id}`, "1"); setB(null); }} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 hover:text-white text-lg" aria-label="Dismiss" data-testid="promo-banner-dismiss">×</button>
    </div>
    <div className="h-10" />
    </>
  );
}

export default function PublicLayout() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/content/settings").then(({ data }) => setSettings(data || {})).catch(() => {});
  }, []);
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-white">
      <PromoBanner />
      <Navbar />
      <main>
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}

export const usePublic = () => useOutletContext();
